import React from 'react';

export const Cancel = ({ customStyles }: { customStyles: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
			className={customStyles}
		>
			<path
				fill="#008635"
				d="M9.031 9.57a.662.662 0 01.899 0L12 11.64l2.031-2.07a.662.662 0 01.899 0 .662.662 0 010 .899L12.86 12.5l2.07 2.07a.662.662 0 010 .899.662.662 0 01-.899 0L12 13.399l-2.07 2.07a.662.662 0 01-.899 0 .662.662 0 010-.899l2.07-2.07-2.07-2.031a.662.662 0 010-.899zM22 12.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10c0-5.508 4.453-10 10-10 5.508 0 10 4.492 10 10zM12 3.75c-4.844 0-8.75 3.945-8.75 8.75A8.736 8.736 0 0012 21.25c4.805 0 8.75-3.906 8.75-8.75 0-4.805-3.945-8.75-8.75-8.75z"
			></path>
		</svg>
	);
};
